<template>
    <el-button
        class="btn btn--delete"
        circle type="danger"
        size="mini"
        @click="$emit('clicked')">
        x
    </el-button>
</template>

<script>
    export default {
        name: 'DeleteBtn',
    };
</script>

<style scoped>
    .btn--delete {
        padding: 2px 5px 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/atoms/button/DeleteBtn.vue